import axios from 'axios';

// export default axios.create({
//     baseURL: 'http://195.133.93.21:5000/'
// });

export default axios.create({
    baseURL: 'https://apis.buybyeq.com/'
});

// export default axios.create({
//     baseURL: 'http://localhost:8080/'
// });

// export default axios.create({
//     baseURL: 'http://157.173.222.191:5000/'
// });

